// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RightSquareFilledSvg from "@ant-design/icons-svg/es/asn/RightSquareFilled";
import AntdIcon from '../components/AntdIcon';

var RightSquareFilled = function RightSquareFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: RightSquareFilledSvg
  }));
};

RightSquareFilled.displayName = 'RightSquareFilled';
export default React.forwardRef(RightSquareFilled);